<template>
  <div class="container" style="margin: 0 !important; max-width: 100% !important; width: 100% !important">
    <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    <b-table
      :key="resourceType"
      :data="data"

      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="updateSorting"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
          {{ props.row._id }}
        </b-table-column>
        <b-table-column class="button-column">
          <b-field addon>
            <router-link class="control"
              :to="{ name: entityDetailsRoute,
                    params: {
                      resourceType: props.row._entityName.split('.').splice(-1)[0].toLowerCase(),
                      resourceId: props.row._id
                    }
                  }"
            >
              <b-tooltip square position="is-top" :label="$gettext('component.entity.list.table.details')">
                <b-icon icon="search" type="is-aquamarine"></b-icon>
              </b-tooltip>
            </router-link>
            <router-link class="control"
              :to="{ name: entityEditRoute,
                    params: {
                      resourceType: props.row._entityName.split('.').splice(-1)[0].toLowerCase(),
                      resourceId: props.row._id
                    }
                  }"
            >
              <b-tooltip v-if="userCanEditByKostenstelle(props.row)" square position="is-top" :label="$gettext('component.entity.list.table.edit')">
                <b-icon icon="edit" type="is-aquamarine"></b-icon>
              </b-tooltip>
            </router-link>
          </b-field>
        </b-table-column>
        <b-table-column
          v-for="bit in tableFields"
          :key="bit.key || bit.field"
          :label="$gettext(bit.label)"
          :visible="bit.tableVisible"
          :field="bit.sortField ? bit.sortField : bit.field"
          :sortable="bit.sortable"
        >
          <fob-entity-value
            :bit="bit"
            :resourceData="props.row[bit.field]"
            :plain="bit.plain"
            :linkNested="bit.linkNested"
          >
          </fob-entity-value>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
// COMPONENTS
import EntityValue from '@/components/EntityValue'
// MIXINS
import UserCanEditByKostenstelle from '@/components/mixins/UserCanEditByKostenstelle'

export default {
  name: 'fob-entity-list-table',
  mixins: [UserCanEditByKostenstelle],
  data () {
    return {
      total: 0,
      defaultSortOrder: 'asc'
    }
  },
  props: {
    data: { default: [] },
    loading: { default: false },
    resourceType: {},
    sortField: {},
    sortOrder: {},
    entityDetailsRoute: { default: 'anzeigen_einzeln' },
    entityEditRoute: { default: 'editieren' },
    tableFields: { default: [] }
  },
  methods: {
    updateSorting (field, order) {
      this.$emit('updateSorting', { field, order })
    }
  },
  components: {
    'fob-entity-value': EntityValue
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EntityListTable.vue